module.exports = __webpack_public_path__ + "static-portal/img/xzz-gyljy.75f4222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-gyljy.jpg
// module id = S0nV
// module chunks = 4